import { Injectable } from "@angular/core";
import * as moment from "moment";
import { Observable, Subject, BehaviorSubject } from "rxjs";
import { Receipt } from "../types/receipt";

@Injectable({
  providedIn: "root"
})
export class DateService {

  private date = new BehaviorSubject<any>({
    date: moment().hours() >= 5 ?
    moment().startOf("day").add(5, "hours") :
    moment().startOf("day").subtract(19, "hours")
  });
  // eslint-disable-next-line @typescript-eslint/member-ordering
  dateStream = this.date.asObservable();

  constructor() {}

  public set(newDate: moment.Moment) {
    this.date.next({ date: newDate });
  }

  public get(): Observable<any> {
    return this.date.asObservable();
  }

}
